import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  RadioGroupForm,
  Heading,
} from "@ogt/ui";

export const WITH_APP = "in_app";
export const WITH_TRAVELCARD = "with_travelcard";
export const WITH_BLIP = "with_blip";
export const WITH_TICKET = "with_ticket";
export const WITH_OTHER = "with_other";

export default function PaymentMethod() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 30;
  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          if (values.paymentmethod === WITH_APP) {
            navigate("/med-app");
          } else if (values.paymentmethod === WITH_TRAVELCARD) {
            navigate("/med-resekort");
          } else if (values.paymentmethod === WITH_BLIP) {
            navigate("/med-blipp");
          } else if (values.paymentmethod === WITH_TICKET) {
            navigate("/med-biljett");
          } else if (values.paymentmethod === WITH_OTHER) {
            navigate("/ersattning-for");
          }
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          paymentmethod: Yup.string().test(
            "at-least-one-radio-selected",
            "Vänligen välj ett svarsalternativ för att gå vidare till nästa steg",
            (value) => {
              return (
                value === WITH_APP ||
                value === WITH_TRAVELCARD ||
                value === WITH_BLIP ||
                value === WITH_TICKET ||
                value === WITH_OTHER
              );
            }
          ),
        })}
      >
        {({ errors }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>
            <Form noValidate>
              <Box>
                <Heading
                  progress={progress}
                  headingRef={h2Ref}
                  focusable
                  id="paymentMethod"
                >
                  Var hade du din biljett?
                </Heading>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                {errors.paymentmethod && (
                  <span
                    aria-describedby="forMe forOther"
                    className="validation-error"
                  >
                    {errors.paymentmethod.toString()}
                  </span>
                )}

                <div className={errors.paymentmethod ? "has-error" : ""}>
                  <RadioGroupForm
                    name="paymentmethod"
                    ariaLabelledBy="paymentmethod"
                    orientation="vertical"
                    variant="box"
                    options={[
                      {
                        id: "withApp",
                        value: WITH_APP,
                        label: "I appen",
                      },
                      {
                        id: "withTravelcard",
                        value: WITH_TRAVELCARD,
                        label: "På ett reskort",
                      },
                      {
                        id: "withBlip",
                        value: WITH_BLIP,
                        label: "Blippat bankkort ombord",
                      },
                      {
                        id: "withTicket",
                        value: WITH_TICKET,
                        label: "Pappersbiljett",
                      },
                      {
                        id: "withOther",
                        value: WITH_OTHER,
                        label: "Inget av ovanstående/jag hade ingen biljett",
                      },
                    ]}
                  />
                </div>
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button
                    onClick={handleSubmitClick(formRef)}
                    className="btn primary"
                    type="submit"
                  >
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
